import React from "react";
import styled from "styled-components";

const Select = (props) => (
    <SelectStyled onChange={(e)=>props.change("font",e.target.value)} value={props.value}>
        <option value="https://fonts.googleapis.com/css?family=Jura:300,700">Font Select</option>
        <option value="https://fonts.googleapis.com/css?family=Jura:300,700">Jura</option>
        <option value="https://fonts.googleapis.com/css2?family=Jost:wght@100;600&display=swap">Jost</option>
		<option value="https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;800&display=swap">Open</option>
		<option value="https://fonts.googleapis.com/css2?family=Inconsolata:wght@200;800&display=swap">Inconsolata</option>
    </SelectStyled>
)

const SelectStyled = styled.select`
	display: block;
	font-size: 16px;
	font-weight: 700;
	color: #444;
	padding: 5px 27px 5px 15px;
	height: 34px;
	line-height: 1.3;
	box-sizing: border-box;
	margin: 0;
	border: none;
	border-radius: 2px;
	-moz-appearance: none;
	-webkit-appearance: none;
	appearance: none;
	background-color: #fff;
	background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E');
	background-repeat: no-repeat, repeat;
	background-position: right .7em top 50%, 0 0;
	background-size: .65em auto, 100%;
`;


export default Select;